import { useState, useEffect } from "react";
import { useMatchesAgainstAJobQuery } from "../graphql/generated/graphql";

const useMatchesAgainstAJob = (jobId: any) => {
  const [matchs, setMatchs]: any = useState(null);
  const { data, loading, error, refetch } = useMatchesAgainstAJobQuery({
    variables: {
      jobId: jobId,
    },
    fetchPolicy: "network-only",
  });
  const loadMatches = () => {
    if (!loading && data) {
      setMatchs(data.matchesAgainstAJob);
    }
  };

  useEffect(() => {
    loadMatches();
  }, [data]);

  return { matchs, refetch };
};

export default useMatchesAgainstAJob;
